module.exports = __webpack_public_path__ + "img/Artboard5.f10b358a.webp";